<template>
  <div class="salesman-form-contract">
    <div class="tools-box">
      <div class="left">
        <Input v-model.trim="keyword" placeholder="请输入合同名称" @on-enter="searchAjax()"/>
        <Icon type="ios-search" @click="searchAjax()"/>
      </div>
      <div class="right">
        <Button class="save-btn" type="primary" @click="daochu" ghost>导出</Button>
        <Button class="save-btn" type="primary" @click="$refs.contractForm.open(userId)" ghost>上传</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <!-- 合同名称 -->
        <template slot-scope="{ row }" slot="subject">
          <span>{{ row.subject }}</span>
        </template>
        <!-- 上传时间 -->
        <template slot-scope="{ row }" slot="createTime">
          <span>{{row.createTime | cutString(10)}}</span>
        </template>
        <!-- 状态 -->
        <template slot-scope="{ row }" slot="status">
          <span v-if="row.status==1" class="status-box">
            <div class="dian"></div>
            已生效
          </span>
          <span v-else-if="row.status==2" class="status-box"> 
            <div class="dian red"></div>
            待生效
          </span>
          <span v-else-if="row.status==-1" class="status-box"> 
            <div class="dian red"></div>
            已过期
          </span>
          <span v-else-if="row.status=='0'" class="status-box"> 
            <div class="dian red"></div>
            已终止
          </span>
          <span v-else class="status-box">-</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div>
            <span class="table-btn" v-if="row.status=='1' && row.type != '3'" @click="stop(row)">终止</span>            
            <span class="table-btn" @click="download(row)" v-if="row.documentUrls">下载合同</span>
            <span class="table-btn red" @click="del(row)">删除</span>
          </div>
        </template>
      </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center"
      />
    </div>

    <!-- 新增合同 -->
    <contract-form ref="contractForm" @reload="searchAjax()"></contract-form>
  </div>
</template>

<script>
import contractForm from './contractForm'
import {pageTool} from "@/api/mixins";
import {config} from "./contract.config.js";
export default {
  mixins:[pageTool,config],
  components: {contractForm},
  props: {},
  data() {
    return {
      keyword:"",
      userId:"",
    };
  },
  mounted() {
    this.userId = this.$route.query.userId;
  },
  methods: {
    setData(){
      this.initListAjax("/buz/userContract/read/list");
    },
    setListParams(params){
      params.employId = this.userId;
      params.subject = this.keyword;
    },
    // 下载合同
    download(item){
      this.$units.downloadFile("/buz/userContract/downloadZipByContract", {
        contractId: item.id,
      });
    },
    stop(item){
      this.$notice.inquiry("确定终止合同吗？").then(()=>{
        this.$http({
          url: "/buz/userContract/edit",
          type: "POST",
          data: {
            id:item.id,
            status:0,
          }
        }).then(res=>{
          this.$notice.success("中止成功");
          this.searchAjax();
        })
      });
    },
    del(item){
      this.$notice.inquiry("确定删除合同吗？").then(()=>{
        this.$http({
          url: "/buz/userContract/del",
          type: "get",
          data: {
            id:item.id,
          }
        }).then(res=>{
          this.$notice.success("删除成功");
          this.searchAjax();
        })
      });
    },
    daochu(){
      this.$units.downloadFile("/buz/userContract/downloadZipByUser",{
        userId:this.userId,
        subject:this.keyword,
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import './contract.scss';
</style>